import React, { useState } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import axios from "axios";
import { Keyboard } from "@material-ui/icons";
import useResponsiveSize from "../../utils/useResponsiveSize";
import jwt_decode from "jwt-decode";
import { toast } from "material-react-toastify";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../route/constant";

export default function Signin() {
  const theme = useTheme();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();
  const [password, setPassword] = useState("");

  const padding = useResponsiveSize({
    xl: 6,
    lg: 6,
    md: 6,
    sm: 4,
    xs: 1.5,
  });

  const login = async () => {
    if (email === "") {
      toast.error("Enter email address");
    } else if (password === "") {
      toast.error("Enter your password");
    } else {
      axios
        .post("https://nowevents.herokuapp.com/login", {
          email: email,
          password: password,
        })
        .then((r) => {
          if (r?.data?.user === "Incorrect email or password") {
            toast.error("Incorrect email or password");
          } else {
            toast.success("Login successfull");
            var decodedHeader = jwt_decode(r.data.user);
            localStorage.setItem("signinToken", r.data.user);
            navigate(ROUTES.DASHBOARD);
            // if (decodedHeader?.user?.role === "admin") {
            //   navigate(ROUTES.DASHBOARD);
            // } else {
            //   navigate(ROUTES.MEETING_LINK);
            // }
          }
        });
    }
  };

  return (
    <form autoComplete="false">
      <Box
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "column",
          height: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Box
          m={9}
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            // backgroundColor: "pink",
          }}
        >
          <Grid
            container
            spacing={padding}
            style={{
              display: "flex",
              flex: 1,
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              // backgroundColor: "purple",
            }}
          >
            <Grid
              item
              xs={12}
              md={4}
              style={{
                width: "100%",
                display: "flex",
                flex: 1,
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",

                // backgroundColor: "pink",
              }}
            >
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <TextField
                    autoComplete={false}
                    id={"inputJoin"}
                    value={email}
                    placeholder="Enter email address"
                    // helperText="Your name will help everyone identify you in the meeting"
                    variant="outlined"
                    fullWidth
                    // value={name}
                    type={"email"}
                    onChange={(ev) => {
                      setEmail(ev.target.value);
                    }}
                  />
                </Box>
              </Box>
              <Box
                style={{
                  width: "100%",
                  display: "flex",
                  flex: 1,
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  marginTop: 10,
                }}
              >
                <Box mt={0} style={{ width: "100%" }}>
                  <TextField
                    id={"inputJoin"}
                    placeholder="Enter your password"
                    // helperText="Your name will help everyone identify you in the meeting"
                    variant="outlined"
                    // error={true}

                    fullWidth
                    value={password}
                    type={"password"}
                    onChange={(ev) => {
                      setPassword(ev.target.value);
                    }}
                  />
                </Box>
              </Box>
              <Button
                style={{ marginTop: 10, width: "100%" }}
                variant="contained"
                onClick={login}
              >
                Login
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </form>
  );
}
